import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  GENERATE_CUSTOMER_REPORT,
  GET_CUSTOMER_GENERATED_REPORTS,
  GET_CUSTOMER_MONTHLY_INVOICES,
  GET_IS_MONTHLY_CUSTOMER,
} from "../../configs/apiConfig";
import { ICustomerGeneratedReport } from "../../typings/interfaces/responses/customer-generated-report-response";
import { IMonthlyInvoice } from "../../typings/interfaces/responses/monthly-invoice-response";

export interface GenerateReportPayload {
  customerId: number;
  reportType: string;
  periodStart: Date | null;
  periodEnd: Date | null;
  billIds?: number[];
}

export const generateCustomerReportAction = createAsyncThunk(
  "customer/generateReport",
  async (payload: GenerateReportPayload, { rejectWithValue }) => {
    try {
      const response = await axios.post<{ body: ICustomerGeneratedReport }>(
        GENERATE_CUSTOMER_REPORT(payload.customerId),
        {
          reportType: payload.reportType,
          periodStart: payload.periodStart,
          periodEnd: payload.periodEnd,
          ...(payload.billIds && payload.billIds.length > 0 ? { billIds: payload.billIds } : {}),
        }
      );
      return response.data.body;
    } catch (err: any) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

export const getCustomerGeneratedReportsAction = createAsyncThunk(
  "customer/getGeneratedReports",
  async (customerId: number, { rejectWithValue }) => {
    try {
      const response = await axios.get<{ body: ICustomerGeneratedReport[] }>(
        GET_CUSTOMER_GENERATED_REPORTS(customerId)
      );
      return response.data.body;
    } catch (err: any) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

export const getCustomerMonthlyInvoicesAction = createAsyncThunk(
  "customer/getMonthlyInvoices",
  async (customerId: number, { rejectWithValue }) => {
    try {
      const response = await axios.get<{ body: IMonthlyInvoice[] }>(
        GET_CUSTOMER_MONTHLY_INVOICES(customerId)
      );
      return response.data.body;
    } catch (err: any) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

export const getIsMonthlyCustomerAction = createAsyncThunk(
  "customer/isMonthlyCustomer",
  async (customerId: number, { rejectWithValue }) => {
    try {
      const response = await axios.get<{ body: boolean }>(
        GET_IS_MONTHLY_CUSTOMER(customerId)
      );
      return response.data.body;
    } catch (err: any) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);
